module.exports = __webpack_public_path__ + "img/halloween-window-22.ce8c1fc0.svg";